<nb-select fullWidth [(selected)]="value" [disabled]="isDisabled">
  <nb-option [value]="undefined">Keine Aggregation</nb-option>
  @for (interval of intervals; track interval) {
    <nb-option [value]="interval">{{ labels[interval] }}</nb-option>
  }
</nb-select>
